import { render } from "./makeupTCModel.vue?vue&type=template&id=66c06057"
import script from "./makeupTCModel.vue?vue&type=script&lang=js"
export * from "./makeupTCModel.vue?vue&type=script&lang=js"

import "./makeupTCModel.vue?vue&type=style&index=0&id=66c06057&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__